// extracted by mini-css-extract-plugin
export default {"checkboxes":"CheckBoxes_checkboxes__rbXbk"};